import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

const FIELDS = ['brand', 'model', 'caliber', 'qrPayload', 'validUntil', 'note'];

function cleanInput(input = {}) {
    const body = {};
    FIELDS.forEach(field => {
        body[field] = String(input[field] == null ? '' : input[field]).trim();
    });
    return body;
}

class WeaponCardStore extends LocalModel {
    constructor() {
        super('weaponCard', {
            namePlural: 'weaponCards',
            namePluralReal: 'weaponcards',
            sort: '-createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/weaponcards/',
                    params: {},
                },
                load: {
                    url: '/api/weaponcards/',
                    params: {},
                },
                save: {
                    url: '/api/weaponcards/',
                    params: {},
                },
                delete: {
                    url: '/api/weaponcards/',
                    params: {},
                },
            },
        });
    }

    @observable weaponCards = [];

    @observable weaponCard = {};

    @observable newWeaponCard = {};

    @observable isLoading = false;

    @observable lastError = '';

    @action
    async loadCards() {
        this.updateKeyValue('isLoading', true);
        const response = await util.fetchApi('/api/weaponcards/', { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('weaponCards', response.data || []);
        }
        this.updateKeyValue('isLoading', false);
        return response;
    }

    @action
    async addCard(input) {
        const response = await util.fetchApi('/api/weaponcards/', { method: 'POST' }, cleanInput(input));
        return this.afterWrite(response, 201);
    }

    @action
    async updateCard(uuidv4, input) {
        const response = await util.fetchApi(`/api/weaponcards/${uuidv4}`, { method: 'PATCH' }, cleanInput(input));
        return this.afterWrite(response, 202);
    }

    @action
    async removeCard(uuidv4) {
        const response = await util.fetchApi(`/api/weaponcards/${uuidv4}`, { method: 'DELETE' }, {});
        return this.afterWrite(response, 202);
    }

    @action
    async afterWrite(response, okStatus) {
        if (response?.status === okStatus) {
            this.updateKeyValue('lastError', '');
            await this.loadCards();
        } else {
            this.updateKeyValue('lastError', response?.message || 'Could not save');
        }
        return response;
    }
}

const store = new WeaponCardStore();
export default store;
